import { MenuBarLink } from "./Link/MenuBarLink";
import { MenuBarDropdown } from "./Dropdown/MenuBarDropdown";
export var MODAL_CHILDREN_ITEMS = {
  LINK: MenuBarLink.name,
  DROPDOWN: MenuBarDropdown.name
};